import { signal } from "@preact/signals-react"

import { DATE_PERIODS } from "@constants"

export const elementsInLoading = signal([])
export const isLoadingByGroupToggle = signal(false)
export const priceDiscountModalData = signal({})
export const evolutionSkuDataFilters = signal({})
export const evolutionSkuCurrentPeriod = signal("")
export const evolutionOffersDataFilters = signal({})
export const evolutionOffersCurrentPeriod = signal("")
export const evolutionOffersDatePeriod = signal(DATE_PERIODS.LAST_7_DAYS)
export const evolutionStockDataFilters = signal({})
export const evolutionStockCurrentPeriod = signal("")
export const priceDiscountEndDate = signal("")
export const isLoadingPriceDiscountModalData = signal(false)

export const resetPricingDiscountData = () => {
    elementsInLoading.value = []
    isLoadingByGroupToggle.value = false
    priceDiscountModalData.value = {}
    evolutionSkuDataFilters.value = {}
    evolutionOffersDataFilters.value = {}
    evolutionOffersDatePeriod.value = {}
    isLoadingPriceDiscountModalData.value = false
}